import DashboardLayout from "../Dashboard/DashboardLayout";
import {useDevice} from "../Dashboard/DeviceContext";
import socket from '../socket.js'
import {useState,useEffect} from 'react'


function Charge() {
  const {selectedDevice, setSelectedDevice} = useDevice({

  });

  const [packages,setPackages]=useState([]);
  const [nowCharge,setNowCharge]=useState (0);
  const [isCreatingPayment,setIsCreatingPayment]=useState(false);

  useEffect (()=>{
    const handlePaymentCreated = (data)=>{
        console.log(data.paymentUrl);
        setIsCreatingPayment (false);
        window.location.assign (data.paymentUrl);
    };
    socket.emit ('get_package',selectedDevice);
    socket.on ("package",(data)=>{
        console.log(data.packages);
        
      setPackages(data.packages);
      setNowCharge (data.charge);
    })
    socket.on ("payment_created",handlePaymentCreated);
   // socket.off ("payment_created",handlePaymentCreated);
    socket.on ("payment_error",(data)=>{setIsCreatingPayment (false);   window.alert (data.message)});

   
  },[]);




    return (
      <DashboardLayout>

<div className="min-h-screen bg-black text-white p-5 md:p-8">

    <h1 className="text-3xl font-black">
        خرید شارژ
    </h1>

    <p className="text-gray-400 mt-2">
        بسته مورد نظر خود را انتخاب کنید.
    </p>



    {/* شارژ فعلی */}

    <div className="mt-8 bg-slate-900 border border-slate-800 rounded-3xl p-6">

        <div className="flex justify-between items-center">

            <span className="text-gray-400">
                شارژ فعلی
            </span>

            <span className="text-3xl font-black text-cyan-400">
                {nowCharge}
            </span>

        </div>

    </div>




    {/* بسته ها */}

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">

        {
            (packages!=undefined)?
            packages.map((item)=>(

                <div

                key={item.id}

                className={`

                rounded-3xl
                p-6
                border
                transition
                hover:-translate-y-1

                ${item.best
                    ? "border-orange-500 bg-slate-900"
                    : "border-slate-800 bg-slate-950"
                }

                `}

                >

                    {

                        item.best &&

                        <div className="inline-block bg-orange-500 text-white text-xs px-3 py-1 rounded-full mb-4">

                            پیشنهاد ویژه

                        </div>

                    }


                    <div className="text-5xl">

                        {item.icon}

                    </div>


                    <h2 className="text-2xl font-black mt-5">

                        {item.title}

                    </h2>


                    <p className="text-5xl font-bold mt-5">

                        {(item.price/10).toLocaleString('en-US')}

                    </p>
                    {(item.price!=item.originalPrice)?
                    <p className="text-3xl text-red-400 line-through">

                        {(item.originalPrice/10).toLocaleString('en-US')}

                    </p>:null}

                    <p className="text-gray-400">

                        تومان

                    </p>


                    <p className="text-orange-400 mt-5">

                        {item.discount}

                    </p>


                    <button

                    className="

                    w-full
                    mt-8
                    bg-orange-500
                    hover:bg-orange-400
                    rounded-2xl
                    py-4
                    font-bold
                    transition

                    "

                    onClick={()=>{

                    socket.emit ("setPayment",{unit:selectedDevice,package:item});
                    setIsCreatingPayment (true);

                    }}

                    >

                        خرید این بسته

                    </button>

                </div>

            ))
            : null

        }

    </div>

</div>
{isCreatingPayment && (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
        
        <div className="flex flex-col items-center justify-center">
            
            {/* Loader */}
            <div className="h-14 w-14 animate-spin rounded-full border-4 border-gray-700 border-t-orange-500"></div>

            {/* متن */}
            <p className="mt-5 text-lg font-medium text-white">
                در حال اتصال به درگاه پرداخت...
            </p>

            <p className="mt-2 text-sm text-gray-400">
                لطفاً کمی صبر کنید
            </p>

        </div>
    </div>
)}
    </DashboardLayout>
  );

}

export default Charge;
